<div class="datagridsidebar__header bg">
    @if (cadvFilters.lastScreen !== cadvFilters.SCREENS.THREE) {
        <a class="back-link" (click)="onBeforeBack($event);" href="#">
            <i class="fa-regular fa-arrow-left"></i> Back</a>
    } @else {
        <h2>View</h2>
    }

    <div class="sidebar__action">
        <span class="advanced-filter hand" (click)="onAdvanceFiltersClick($event)">Applied filters ({{ cadvFilters.getFiltersLength() }})</span>
        <a class="close" (click)="onClose($event)"><i class="fa-regular fa-times"></i></a>
    </div>
</div>


@if (cadvFilters.currentField) {
<div class="adv-creator view-content">
    <div class="flex-row--inner">
        <div class="flex-col-sm-12">
            <h5>{{ cadvFilters.currentField.label }}</h5>
        </div>
    </div>
    <div class="options">
        @for (option of cadvFilters.currentField.options; track optIndex; let optIndex = $index) {
        <div class="option">
            <div class="datagrid-radio-list">
                <p-radioButton [value]="option.value" [(ngModel)]="cadvFilters.currentField.operatorName"
                    (ngModelChange)="cadvFilters.currentField.operatorLabel = option.label;"
                    [inputId]="option.label">
                </p-radioButton>
                <label [for]="option.label">{{ option.label }}</label>
            </div>
            @if (option.field_options?.length > 0) {
            <div class="field_options d-flex align-items-center justify-content-between flex-direction-column" style="gap: 7px;">
                @for (fopt of option.field_options; track index; let index = $index) {
                @if (cadvFilters.currentField.operatorName === option.value && fopt.type === 'chip') {
                <div class="values" [style]="{ width: '100%' }">
                    <p-chips 
                        #chip
                        separator=","
                        [style]="{ width: '100%' }" 
                        [placeholder]="'Hint: Value1, Value2'"
                        (onBlur)="onChipBlur($event, chip, fopt)"
                        [(ngModel)]="fopt.selected_list" 
                        (ngModelChange)="onChange();">
                    </p-chips>
                </div>
                }
                @if (cadvFilters.currentField.operatorName === option.value && fopt.type === 'dropdown') {
                <div class="values" [style]="{ width: '100%' }">
                    @if (fopt.label) {
                    <label>{{ fopt?.label }} {{ fopt.selected }}</label>
                    }
                    <div class="action__item dropdown--container" [style]="{ width: '100%' }">
                        <div class="dropdown-list action__item dropdown--container" [style]="{ width: '100%' }">
                            <f-dropdown [placeholder]="fopt.placeholder" [style]="{ width: '100%' }" [(ngModel)]="fopt.selected"
                                (ngModelChange)="onChange();" [options]="fopt.values"></f-dropdown>
                        </div>
                    </div>
                </div>
                }
                @if (cadvFilters.currentField.operatorName === option.value && fopt.type === 'multiselect') {
                    <div class="values" [style]="{ width: '100%' }">
                        @if (fopt.label) {
                        <label>{{ fopt?.label }} {{ fopt.selected }}</label>
                        }
                        <div class="single-input-field-wrapper">
                            <f-multiSelect display="chip" [placeholder]="fopt.placeholder" [style]="{ width: '100%' }" [(ngModel)]="fopt.selected_list"
                                (ngModelChange)="onChange();" [optionValue]="'name'" [optionLabel]="'name'" [options]="fopt.values"></f-multiSelect>
                        </div>
                    </div>
                }
    
                @if (cadvFilters.currentField.operatorName === option.value && fopt.type === 'date') {
                <div class="values" [style]="{ width: '100%' }">
                    @if (fopt.label) {
                    <label>{{ fopt?.label }}</label>
                    }
                    <p-calendar [placeholder]="fopt.placeholder" [style]="{ width: '100%' }" [(ngModel)]="fopt.selected"
                        (ngModelChange)="onChange();"></p-calendar>
                </div>
                }
                @if (cadvFilters.currentField.operatorName === option.value && fopt.type === 'time') {
                    <div class="values" [style]="{ width: '100%' }">
                        @if (fopt.label) {
                        <label>{{ fopt?.label }}</label>
                        }
                        <p-calendar 
                            [timeOnly]="true"
                            [showTime]="true"
                            [placeholder]="fopt.placeholder" [style]="{ width: '100%' }" [(ngModel)]="fopt.selected"
                            (onBlur)="onChange();"></p-calendar>
                    </div>
                }
                @if (cadvFilters.currentField.operatorName === option.value && fopt.type === 'input') {
                <div class="values" [style]="{ width: '100%' }">
                    @if (fopt.label) {
                    <label>{{ fopt?.label }}</label>
                    }
                    <input [type]="fopt.inputType" class="form-control form-fields__input"
                        [placeholder]="fopt.placeholder" [style]="{ width: '100%' }" [(ngModel)]="fopt.selected"
                        (ngModelChange)="onChange();" />
                </div>
                }
                }
            </div>
            }
        </div>
        }
    </div>
    <br />
    @if (!isNextDisabled()) { <button (mousedown)="$event.preventDefault(); applyFilter($event)" class="btn-bg">Next</button> }
</div>
}